module.exports = __webpack_public_path__ + "static/media/MachineLearningMiddle.76302f65.svg";